import { render, staticRenderFns } from "./GaleriaImagemBannerComponent.vue?vue&type=template&id=95ff0cc2&scoped=true"
import script from "./GaleriaImagemBannerComponent.vue?vue&type=script&lang=js"
export * from "./GaleriaImagemBannerComponent.vue?vue&type=script&lang=js"
import style0 from "./GaleriaImagemBannerComponent.vue?vue&type=style&index=0&id=95ff0cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ff0cc2",
  null
  
)

export default component.exports